import { Component, inject } from "@angular/core";
import { EmailSenderService } from "../../data/services/email-sender.service";

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent {

    public emailSender: EmailSenderService = inject(EmailSenderService);

    constructor()  {}
}